import { border } from "@smartsheet/design-tokens";
import { themed } from "../../../util/theme";
import { BaseButtonStyledProps } from "../types";

const borderTheme = themed({
    "lodestar-light": border.radius10,
    "ursa-light": border.radius20,
});

export const getButtonBorderRadius = ({ themeMode }: BaseButtonStyledProps) => {
    return borderTheme(themeMode);
};
